
import { defineComponent, getCurrentInstance, reactive } from 'vue'
import ManagementLayout from '@/layout/ManagementLayout.vue'
import { useRouter } from 'vue-router'
import { usrState, News, updateResource } from '@/model'
import { formatTime, isAuthUserAdmin } from '@/utils'
import { ElLoading } from 'element-plus'
import api from '@/api'

export default defineComponent({
  name: 'ManageNewsListPage',
  components: {
  },
  created() {
    this.$emit('update:layout', ManagementLayout)
  },
  setup() {
    const proxy = getCurrentInstance()?.proxy
    const router = useRouter()

    const state = reactive({
      isAdmin: false,
      news: usrState.news,
      loading: false,
    })

    isAuthUserAdmin().then(isAdmin => {
      state.isAdmin = isAdmin
    })

    const handleEdit = (index: number, item: News) => {
      router.push('/admin/news/' + item.id)
    }

    const handleDelete = (index: number, news: News) => {
      console.log('handleDeleteNews', { index, news })
      proxy?.$confirm(`確認刪除「${news.title}(${news.id})」？`)
        .then(async () => {
          const loading = ElLoading.service({
            lock: true,
            text: 'Loading',
            background: 'rgba(0, 0, 0, 0.7)',
          })

          api.deleteNews(news.id)
            .then(() => updateResource())
            .then(() => loading.close())
            .catch(() => loading.close())
        })
        .catch(() => { /* prevent exception */ })
    }

    return {
      state,
      handleEdit,
      handleDelete,
      formatTime,
    }
  },
})
